goog.provide("shadow.js.shim.module$$mui$material$SvgIcon$default");
shadow.js.shim.module$$mui$material$SvgIcon$default = shadow.js.shim.module$$mui$material$SvgIcon.default;
